export default {
  api: {
    vwf: 'https://financing.vwfinance.ca/index.html'
  },
  url: {
    batd: {
      en: 'https://www.vw.ca/en/forms/testdrive.html',
      fr: 'https://www.vw.ca/fr/formes/essai-routier.html'
    }
  },
  scripts: {
    jquery: 'https://code.jquery.com/jquery-3.4.1.min.js',
    estimates: 'https://inventory.dev.build.vwtools.ca',
    motocommerce:
      'https://volksklick.motocommerce.ca/integration/integration.js',
  },
  calculator: {
    financeRate: {
      id: 2,
      name: 'Volkswagen Financing',
    },
  },
  filters: {
    valid: [
      'postal_code',
      'province',
      'distance',
      'category',
      'dealer',
      'model',
      'mileage',
      'year',
      'price',
      'color_exterior',
      'color_interior',
      'transmission',
      'trimline',
      'vehicle_type',
    ],
    display: [
      'price',
      'mileage',
      'trimline',
      'transmission',
      'color_exterior',
      'color_interior',
      'vehicle_type',
      'category',
      'year',
      'model',
    ],
    multiple: [
      'color_exterior',
      'color_interior',
      'trimline',
      'transmission',
      'category',
      'price',
      'mileage',
      'year',
      'model',
    ],
  },
  models: {
    atlas : 'Atlas',
    atlascrosssport : 'Atlas Cross Sport',
    id4: 'ID.4',
    jetta: 'Jetta',
    jettagli: 'Jetta', // pass jetta model instead of jettagli to motoinsights api
    golfgti: 'Golf GTI',
    golfr: 'Golf R',
    idbuzz: 'ID. Buzz',
    tiguan: 'Tiguan',
    taos: 'Taos',
    id7: 'ID.7'
  }
};
